import type { UseQueryResult } from '@tanstack/react-query';
import { useBasicQuery } from '@hooks/requests/utils/use_basic_query';
import { PARTNER_MESSAGES_TOTAL_PATH } from '@hooks/requests/utils/paths';

export interface PartnerMessagesTotal {
  organizationId: string;
  companyId: string | null;
  userId: string | null;
  from: string;
  to: string;
  totalMessages: number;
}

export interface MessagesTotalParams {
  from?: string;
  to?: string;
  companyId?: string;
  /** Drill-down to a single user. */
  userId?: string;
}

export const useMessagesTotalQuery = (
  params: MessagesTotalParams = {},
  options: { enabled?: boolean } = {}
): UseQueryResult<PartnerMessagesTotal, Error> =>
  useBasicQuery<PartnerMessagesTotal>(PARTNER_MESSAGES_TOTAL_PATH, params, {
    enabled: options.enabled,
  });
